// extracted by mini-css-extract-plugin
export default {"header":"MQBPp_GNdpLkzK92kvwc"};